import {
  SupplementalData,
  SupplementalDataTypes,
} from '@dispatch/shared/types';
import { Grid, TextField } from '@mui/material';

export const CreateField = (data: SupplementalData) => {
  switch (data.type) {
    case SupplementalDataTypes.MULTI_LINE_TEXT:
      return (
        <Grid item xs={12}>
          <TextField
            id={data.key}
            label={data.label}
            inputProps={{
              readOnly: true,
            }}
            multiline
            variant={'standard'}
            value={data.value}
            fullWidth
          />
        </Grid>
      );
    // should never reach here
    case SupplementalDataTypes.SINGLE_LINE_TEXT:
    default:
      return (
        <Grid item xs={6}>
          <TextField
            id={data.key}
            label={data.label}
            inputProps={{
              readOnly: true,
            }}
            variant={'standard'}
            value={data.value}
            fullWidth
          />
        </Grid>
      );
  }
};
